import { Label } from '@/components/ui/shadcn/label';
import { Switch } from '@/components/ui/shadcn/switch';
import { useTranslations } from '@/hooks/useTranslations';
import { router } from '@inertiajs/react';
import { useState } from 'react';
import { toast } from 'sonner';
import { route } from 'ziggy-js';

interface LocaleToggleProps {
    value: string;
    onUpdate: (value: string) => void;
    disabled?: boolean;
}

export function LocaleToggle({ value, onUpdate, disabled = false }: LocaleToggleProps) {
    const { t } = useTranslations();
    const [processing, setProcessing] = useState(false);
    const isEnglish = value === 'en';

    const handleToggle = (checked: boolean) => {
        if (processing || disabled) {
            return;
        }

        const newValue = checked ? 'en' : 'lt';
        setProcessing(true);

        router.patch(
            route('settings.system.update', 'app.locale'),
            { value: newValue },
            {
                preserveScroll: true,
                onSuccess: () => {
                    toast.success(t('toasts.settings_localetoggle.locale_updated', 'Locale updated successfully'));
                    onUpdate(newValue);
                },
                onError: () => {
                    toast.error(t('toasts.settings_localetoggle.locale_update_failed', 'Failed to update locale'));
                },
                onFinish: () => {
                    setProcessing(false);
                },
            },
        );
    };

    return (
        <div className="flex items-center gap-3">
            <Label htmlFor="locale-toggle" className="text-sm font-normal">
                {isEnglish ? 'English' : 'Lietuvių'}
            </Label>
            <Switch id="locale-toggle" checked={isEnglish} onCheckedChange={handleToggle} disabled={disabled || processing} />
            <Label htmlFor="locale-toggle" className="text-muted-foreground text-sm font-normal">
                {isEnglish ? 'Lietuvių' : 'English'}
            </Label>
        </div>
    );
}
